export const getPageNumber = (total: number, defaultPageSize: number) => {
  if (total <= defaultPageSize) return 1;

  return Math.ceil(total / defaultPageSize);
};
